import { connect } from "react-redux";
import React, { Component } from "react";

import { ContainerContent } from "@/components/Common/Dashboard/ContainerContent";
import { ContainerTitle } from "@/components/Common/Dashboard/ContainerTitle";

import { api } from "../../../APIRequests";
import Profile from "../../../components/Patient/Profile/Profile";
import ProfileLoader from "../../../components/Common/Loaders/ProfileLoader";
import { setDynamicRouteConfiguration } from "../../../redux/actions/navbar";

import { loadPatientInsuranceImagesUrlToState } from "./PatientInsurance";

class PatientProfile extends Component {
  state = {
    patientProfile: null,
    patientAvatar: null,
    insuranceImageUrls: {
      pfUrl: null,
      pbUrl: null,
      sfUrl: null,
      sbUrl: null,
    },
  };

  componentDidMount() {
    const dynamicRouteConfig = {};

    dynamicRouteConfig["logoSection"] = { title: "Profile" };
    this.props.setDynamicRouteConfiguration(dynamicRouteConfig);
    this.getProfile();
  }
  componentWillUnmount() {
    this.props.setDynamicRouteConfiguration({});
  }

  getProfile = async () => {
    try {
      const options = { params: { showLoader: false } };
      let response = await api.patient.fetch_profile({ options });

      this.setState({
        patientProfile: response && response.user,
      });
      loadPatientInsuranceImagesUrlToState(response.user, this);
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    return (
      <ContainerContent>
        <ContainerTitle title="Profile" />

        {this.state.patientProfile ? (
          <Profile
            profileData={this.state.patientProfile}
            insuranceImageUrls={this.state.insuranceImageUrls}
            reloadImg={(user) => loadPatientInsuranceImagesUrlToState(user, this)}
          />
        ) : (
          <ProfileLoader />
        )}
      </ContainerContent>
    );
  }
}

export default connect(null, { setDynamicRouteConfiguration })(PatientProfile);
